import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_SUPPLIER_FILE_ATTACHMENTS_QUERY = graphql(/* GraphQL */ `
  query NegotiationCaseSupplierFileAttachments(
    $negotiationCaseId: UUID!
    $parents: [TsrctAttachmentParentInput!]!
    $filter: TsrctAttachmentFilterInput
  ) {
    tesseract {
      attachments(parents: $parents, filter: $filter) {
        ...FileAttachment
      }
      negotiationCase(id: $negotiationCaseId) {
        id
        status
      }
    }
  }
`);
